import { createFileRoute } from '@tanstack/react-router'

import { ShiftPage } from '@/pages/shift-page'

export const Route = createFileRoute('/_master-layout/_dashboard-layout/shifts/$id')({
    component: ShiftPage,
    params: {
        parse: (params) => ({ id: Number(params.id) }),
    },
})
